import React from 'react';
import { BodyS } from 'components/Typography/Typography';
import Attention from 'assets/img/icons/attention.svg';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/views/prepaidLoyalty/tableRowInfoStyle';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ITableInfoRow {
	text: string;
}

const TableInfoRow = ({ text }: ITableInfoRow) => {
	const classes = useStyles();

	return (
		<div className={classes.neutralBackground}>
			<div className={classes.rowWrapper}>
				<img src={Attention} alt="Note icon" className={classes.image} />
				<BodyS color="brand-secondary" disableMargin>
					{text}
				</BodyS>
			</div>
		</div>
	);
};

export default TableInfoRow;
